module.exports = __webpack_public_path__ + "img/basemap_topomap.46b2753e.png";